/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import analytics from "analytics/analytics";
import cookie from "utils/cookie";
import baustein from "baustein";
import environment from "modules/environment";
import globals from "modules/globals";

const EU_COUNTRIES = new Set([
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    "GB"
]);

const componentName = "bottom-notification";
const closeButtonSelector = `.${componentName}__close`;

const consentCookieName = "cookieconsent";
const consentCookiePeriod = 365;

export default baustein.register(componentName, {
    setupEvents(add) {
        add("click", closeButtonSelector, this.hideNotification);
    },

    init() {
        if (!this.hasConsentCookie() && this.isEUCountry()) {
            this.showNotification();
        }
    },

    isEUCountry() {
        return EU_COUNTRIES.has(environment.get("country"));
    },

    hasConsentCookie() {
        return Boolean(cookie(consentCookieName));
    },

    showNotification() {
        analytics.event("Cookie consent", "Shown", null, true);
        this.el.classList.remove("hidden");
    },

    hideNotification() {
        this.el.classList.add("hidden");
        this.setConsentCookie();
        analytics.event("Cookie consent", "Clicked", "Hide");
    },

    setConsentCookie() {
        cookie(consentCookieName, 1, {
            expires: consentCookiePeriod,
            path: "/",
            withEncoding: false,
            domain: this.getCookieDomain()
        });
    },

    getCookieDomain() {
        let hostnameParts = globals.window.location.hostname.split(".");

        if (hostnameParts.includes("www") || hostnameParts.includes("checkout")) {
            return hostnameParts.slice(1).join(".");
        }
    }
});

